import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import DownloadDataset from './DownloadDataset';
import UploadDatasetModal from './UploadDatasetModal';
import DatasetParameters from 'components/Dataset/DatasetParameters';

import { areParametersSelected } from 'store/dataset';

const fileSaverSupported = !!new Blob();

const useShowDownloadDatasetModalTrigger = () => {
  const parametersSelected = useSelector(state => areParametersSelected(state));
  const [showDownloadDatasetModalTrigger, setShowDownloadDatasetModalTrigger] = useState(false);

  useEffect(() => {
    setShowDownloadDatasetModalTrigger(parametersSelected && fileSaverSupported);
  }, [parametersSelected]);

  return showDownloadDatasetModalTrigger;
};

const UploadUserComponent = ({ fileChange, defaultTypesVariables, activeIndex, isDataSet, isFrequencyTable, isErrorType }) => {
  const showDownloadDatasetModalTrigger = useShowDownloadDatasetModalTrigger();
  const uploadComponent = () =>
    (<UploadDatasetModal onFileChange={fileChange} isErrorType={isErrorType} />);

  return (
    <div>
      {activeIndex === 1 ? (
        <>
          {isDataSet && !isFrequencyTable && <DatasetParameters defaultTypesVariables={defaultTypesVariables} />}
          {showDownloadDatasetModalTrigger && <DownloadDataset />}
        </>
      ) : uploadComponent()
      }
    </div>
  );
};


UploadUserComponent.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  isDataSet: PropTypes.bool.isRequired,
  isErrorType: PropTypes.bool.isRequired,
  isFrequencyTable: PropTypes.bool.isRequired,
  datasetFile: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  defaultTypesVariables: PropTypes.object.isRequired,
  fileChange: PropTypes.func.isRequired
};

export default UploadUserComponent;
